import MainController from './highway/MainController';

export default function common() {
	let controller = new MainController(),
		scroll = controller.getScroll();

	// Footer scroll to Top
	let footerLinks = document.querySelectorAll('#footer .menu-item a'),
		currentLocation = window.location.href;
	footerLinks.forEach(link => {
		link.addEventListener('click', function(ev) {
			if (link.hash) {
				ev.preventDefault();
				scroll.scrollTo(link.hash);
			} else if (link.href == currentLocation) {
				ev.preventDefault();
				scroll.scrollTo('top');
			}
		});
	});

	/* Full Height with javascript (100vh doesnt play well with mobile) */
	let fullHeightItems = document.getElementsByClassName('js-100vh');
	for (let index = 0; index < fullHeightItems.length; index++) {
		const element = fullHeightItems[index];
		element.style.height = window.innerHeight + 'px';
	}

	/* Scroll down  */
	document.addEventListener('click', event => {
		let target = event.target;

		if (!target.classList.contains('scroll-to')) {
			return;
		}

		let scrollToTarget = document.querySelector('[data-anchor="' + target.dataset.goto + '"]');

		scroll.scrollTo(scrollToTarget);
	});
}



// WEBPACK FOOTER //
// ./scripts/common.js